module.exports = __webpack_public_path__ + "img/Role Management.8bb21bb9.svg";